import ReactGA from 'react-ga4';

const TRACKING_ID = "G-H4VYYP35M9"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.send({ hitType: "pageview", page: (window.location.pathname + window.location.search)});
};